import { useContext } from "react";
import { CarCompetitionData } from "../contextProvider";
import useXcCompetition from "../useXcCompetition";

const LastChance = ({ variant = "default" }: { variant?: "default" | "hero" }) => {
  const carData = useContext(CarCompetitionData);
  const carCompetition = useXcCompetition();
  const isHero = variant === "hero";
  const title = carData.prizeTitle || carCompetition.FeaturedPrizeModel;
  const cashLine = carData.cashAlternativeText ? `Or take ${carData.cashAlternativeText} in cash` : null;

  return (
    <div className="flex flex-col justify-center items-center gap-2 self-stretch font-jost">
      <div
        className={
          isHero
            ? "text-white text-center text-[32px] lg:text-[42px] font-black leading-10 lg:leading-[56px] uppercase lg:[text-shadow:0_2px_4px_rgba(0,0,0,0.70)]"
            : "text-dark-1 text-center text-[22px] font-black leading-normal uppercase"
        }>
        {title}
      </div>
      {!carData.hideCashAlternative && cashLine ? (
        <div
          className={
            isHero
              ? "text-white text-center text-[22px] lg:text-[28px] font-normal leading-7 lg:leading-8 lg:[text-shadow:0_2px_4px_rgba(0,0,0,0.70)]"
              : "text-secondary text-center text-lg font-normal leading-6"
          }>
          {cashLine}
        </div>
      ) : null}
    </div>
  );
};

export default LastChance;
